import type { OperatingHoursRange } from '#api/shared/@types/generated/backend/graphql-schema-types'

import { getHighFrequencyGameResume } from '../utils/highFrequencyGameResume'

// Teasers are server-rendered and cached, so the day count waits for the viewer's clock and
// timezone after mount, just like NuxtTime does for the time next to it
export const useHighFrequencyTeaserResumeDays = (
  operatingHours: MaybeRefOrGetter<Maybe<OperatingHoursRange> | undefined>,
) => {
  const isMounted = useMounted()

  return computed(() => {
    const nextStart = toValue(operatingHours)?.nextStart

    return isMounted.value && nextStart ? getHighFrequencyGameResume(nextStart).days : 0
  })
}
